
window.community = window.community || {};

(function(){
  'use strict';
  var selectors = {
    form: document.querySelector('.community-form'),
  };

  community.utils = {
    serialize: function(form) {
      var arr = [];
      Array.prototype.slice.call(form.elements).forEach(function(field) {
        if (
          !field.name ||
          field.disabled ||
          ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
        )
          return;
        if (field.type === 'select-multiple') {
          Array.prototype.slice.call(field.options).forEach(function(option) {
            if (!option.selected) return;
            arr.push(
              encodeURIComponent(field.name) +
                '=' +
                encodeURIComponent(option.value)
            );
          });
          return;
        }
        if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
          return;
        arr.push(
          encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
        );
      });
      return arr.join('&');
    },
    isLogin: function() { return; // Legacy community login disabled
      var userid = communityData.userid || '';
      var email = communityData.email || '';

      if(userid == '' || email == '') {
        return;
      }
      
      fetch("https://lampaous.kufei.xyz/api/v1/user/login", {
          method: 'POST',
          body: 'userid='+userid+'&email='+email,
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => response.json())
        .then(function(data) {
          if (data.code === 1) {
            window.localStorage.setItem('community-token', data.data.token);
            console.log("成功")
          } else {
            console.log("失败")
          }
      });
    },
    getCommunityToken: function() {
      return window.localStorage.getItem("community-token") || ""
    }
  }
  
  community.Disclosure = (function() {
    var status = {
      loading: false
    };
    var selectors = {
      disclosureToggle: '.community-header__link-account',
      disclosureList: '.community-header__account-dropdown',
    };
    var classes = {
      listVisible: 'disclosure-list--visible'
    };
    
    function Disclosure(disclosure) {
      this.container = disclosure;
      this._cacheSelectors();
      this._setupListeners();
      this._renderArticleThumbnail();
    };
    
    Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
      _cacheSelectors: function() {
        this.cache = {
          disclosureToggle: this.container.querySelector(
            selectors.disclosureToggle
          ),
          disclosureList: this.container.querySelector(
            selectors.disclosureList
          ),
        };
      },
      _setupListeners: function() {
          this.eventHandlers = this._setupEventHandlers();

          this.cache.disclosureToggle.addEventListener(
            'click',
            this.eventHandlers.toggleList
          );

          const account_dropdown = document.getElementById("community-header__link-account")
          const account_dropdown_content = document.getElementById("community-header__account-dropdown")

          window.addEventListener('click', function(e){
            if (event.target === account_dropdown || event.target.parentNode === account_dropdown) {
                return; // 若点击了弹窗本身或其子元素则返回，不进行关闭操作
            } else {
                account_dropdown_content.classList.remove('disclosure-list--visible')
                account_dropdown_content.setAttribute('aria-expanded', 'false');
                account_dropdown.setAttribute('aria-expanded', 'false');
                // 注意：只有在点击非弹窗区域才会调用此函数，因此无需再次手动移除点击事件监听器
                // window.removeEventListener('click', closePopup);
            }
          });
      },
      _setupEventHandlers: function() {
        return {
          toggleList: this._toggleList.bind(this),
        };
      },
      _toggleList: function() {
        var ariaExpanded =
          this.cache.disclosureToggle.getAttribute('aria-expanded') === 'true';
          this.cache.disclosureList.classList.toggle(classes.listVisible);
          this.cache.disclosureToggle.setAttribute('aria-expanded', !ariaExpanded);
      },
      _renderArticleThumbnail: function() {
        const post_items = document.querySelectorAll(".community-post__item");
        const imgSrcRegex = /<img[^>]*src="([^"]+)"[^>]*>/g;
        post_items.forEach(function(item, key) {
            const media_list = item.querySelector(".post-item__media");
            const media_content = item.querySelector(".ajax-content");
            const media_content_html = media_content.innerHTML;
            const srcs = [];
            let match;
            while ((match = imgSrcRegex.exec(media_content_html))) {
              srcs.push(match[1]);
            }
            if(srcs.length) {
                let html = "";
                srcs.forEach(imageUrl => {
                  html += '<div class="post-item__media-item"><img src="'+imageUrl+'" alt=""></div>'
                  // 将img元素追加到容器元素中
                  media_list.innerHTML = html;
               });
            }
        })
      }
    });
    
    return Disclosure;
  })();

  new community.Disclosure(document.querySelector(".community-page"));

  // community.utils.isLogin();
})();